import React, { useEffect, useState, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { message, Input, Drawer, Space, Modal, Button as Buttons, Spin } from 'antd'; // Popover, Checkbox 
import 'react-tagsinput/react-tagsinput.css';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { PDFViewer } from '@react-pdf/renderer';
import {
    Image as ImageIcon,
    FileText,
    FileSpreadsheet,
    Presentation,
    FileVideo,
    FileAudio,
    FileArchive,
    File as FileIcon,
} from 'lucide-react';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import propTypes from 'prop-types';
import { MailBox2 } from './email-style';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import { ExchangeCurrency } from '../Filters/FilterConditions';
import { FetchAllAttendeeList, FecthModuleEncryptedToken, getExchangeRate } from '../../../Api/Services/CommonApiService'
import { FetchAllRecentMails1, sendTemplateMail, selectEmailTemplate } from '../../../Api/Services/EmailApiSevices';
import { Button } from '../../../components/buttons/buttons';
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import QuotationPdf from '../QISC/PdfComponents/QuotationPdf';
import SalesPdf from '../QISC/PdfComponents/SalesOrderPdf';
import InvoicePdf from '../QISC/PdfComponents/InvoicePdf';
import TemplateSelect from '../Popup/TemplateSelectPopup'
import { InsertTempIcon } from '../../../components/Icons/Icons';

const C = {
    teal: "#0d9488", tealSoft: "#ccfbf1",
    rose: "#e11d48", roseSoft: "#ffe4e6",
    accent: "#4183f1", accentSoft: "#e3edff",
    green: "#16a34a", greenSoft: "#dcfce7",
    orange: "#ea580c", orangeSoft: "#ffedd5",
    violet: "#7c3aed", violetSoft: "#ede9fe",
    blue: "#2563eb", blueSoft: "#dbeafe",
    amber: "#d97706", amberSoft: "#fef3c7",
    inkMuted: "#6b7280", sunken: "#f3f4f6",
};

const getFileExt = (filename = "") => {
    const idx = filename.lastIndexOf(".");
    return idx > -1 ? filename.slice(idx + 1).toLowerCase() : "";
};

function fileTypeMeta(ext) {
    const image = ["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp", "ico", "avif"];
    const doc = ["doc", "docx", "txt", "rtf"];
    const sheet = ["xls", "xlsx", "csv"];
    const pdf = ["pdf"];
    const video = ["mp4", "webm", "mov"];
    const archive = ["zip", "rar", "7z"];
    const presentation = ["ppt", "pptx"];
    const audio = ["mp3", "wav", "aac", "ogg", "m4a"];
    if (image.includes(ext)) {
        return { label: "Image", icon: ImageIcon, color: C.teal, soft: C.tealSoft };
    }
    if (pdf.includes(ext)) {
        return { label: "PDF", icon: FileText, color: C.rose, soft: C.roseSoft };
    }
    if (doc.includes(ext)) {
        return { label: "Document", icon: FileText, color: C.accent, soft: C.accentSoft };
    }
    if (sheet.includes(ext)) {
        return { label: "Spreadsheet", icon: FileSpreadsheet, color: C.green, soft: C.greenSoft };
    }
    if (presentation.includes(ext)) {
        return { label: "Presentation", icon: Presentation, color: C.orange, soft: C.orangeSoft };
    }
    if (video.includes(ext)) {
        return { label: "Video", icon: FileVideo, color: C.violet, soft: C.violetSoft };
    }
    if (audio.includes(ext)) {
        return { label: "Audio", icon: FileAudio, color: C.blue, soft: C.blueSoft };
    }
    if (archive.includes(ext)) {
        return { label: "Archive", icon: FileArchive, color: C.amber, soft: C.amberSoft };
    }
    return {
        label: ext ? ext.toUpperCase() : "File",
        icon: FileIcon,
        color: C.inkMuted,
        soft: C.sunken,
    };
}
function Compose({ close, mailOpen, entity, entityId, entityName, toId, AllData, invoiceToken, MailContent, SubjectData, attachFile, updateStatus, updateId, setNaCTrigger }) {
    const WebUrl = process.env.REACT_APP_BASE_URL_WEB
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyDetals = localData.company
    const [popupMessage, setPopupMessage] = useState(false)
    const [state, setState] = useState({
        size: 'big',
        tags: [],
    });
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const [disabled, setDisbled] = useState(false)
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [composeSize, setComposeSize] = useState(entityName === "cases" ? 600 : 1400)
    const [linkType, setLinkType] = useState('Contacts_Leads,Accounts');
    const [subject, setSubject] = useState("")
    const [content, setContent] = useState("");
    const [files, setFiles] = useState([]);
    const [companyToken, setCompanyToken] = useState()
    const [stripeToken, setStripeToken] = useState()
    const [amountToken, setAmountToken] = useState()
    const [paymentLinkAdded, setPaymentLinkAdded] = useState(false)
    const [openTemplate, setOpenTemplate] = useState(false)
    const [templateId, setTemplateId] = useState({ id: null, key: 0 })
    const toggleSize = (value) => {
        setComposeSize(value)
    }
    const sanitizeEmailContent = (html) => {
        if (!html) return html;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // 1. Remove open-rate tracking pixel
        doc.querySelectorAll("img").forEach((img) => {
            const src = img.getAttribute("src") || "";
            if (src.includes("/api/openRates/")) {
                const parent = img.parentElement;
                if (parent && parent.children.length === 1 && parent.tagName === "DIV") {
                    parent.remove(); // remove wrapping div too
                } else {
                    img.remove();
                }
            }
        });

        // 2. Remove unsubscribe block
        doc.querySelectorAll('[id^="unsubscribe-block"]').forEach((el) => el.remove());

        // 3. Unwrap clickURL tracking -> keep only real redirect target
        const clickUrlPattern = /\/api\/clickURL\/[^/]+\/[^/?]+\?redirect=(.+)/;
        doc.querySelectorAll("[href], [src]").forEach((el) => {
            ["href", "src"].forEach((attr) => {
                const val = el.getAttribute(attr);
                if (!val) return;
                const match = val.match(clickUrlPattern);
                if (match) {
                    try {
                        el.setAttribute(attr, decodeURIComponent(match[1]));
                    } catch {
                        el.setAttribute(attr, match[1]);
                    }
                }
            });
        });

        return doc.body.innerHTML;
    };
    const MergeAiContent = (value) => {
        const aiContent = value?.content
        if (!aiContent) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(content || "<div><br></div>", "text/html");
        const nonEditable = doc.querySelector("div[contenteditable='false']");
        if (nonEditable) {
            let node = doc.body.firstChild;
            while (node && node !== nonEditable) {
                const next = node.nextSibling;
                node.remove();
                node = next;
            }
            nonEditable.insertAdjacentHTML("beforebegin", aiContent);
            setContent(doc.body.innerHTML);
        } else {
            setContent(aiContent)
        }
        // setSubject(value?.templateSubject)

        const cleaned = sanitizeEmailContent(aiContent);
        setContent(cleaned);
    };
    async function getcontent() {
        try {
            const data = await selectEmailTemplate(templateId.id, "Cases", entityId)
            MergeAiContent(data);
            setTemplateId({ id: null, key: 0 })
        } catch (error) {
            setTemplateId({ id: null, key: 0 })
            message.error(error);
        }
    }
    const onEmailSend = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
        setDisbled(true)
        const payload = {
            to: state.tags,
            content: formattedHtmlContent,
            subject: normalizeValue(subject),
            attachments: files,
        }
        let hideMessage;
        try {
            hideMessage = message.loading("Sending Email", 0);
            const response = await sendTemplateMail(linkType, payload)
            if (response.status === 201) {
                setTimeout(() => {
                    FetchAllRecentMails1("Sent")
                        .then(() => {
                            if (entityName === "cases") {
                                setNaCTrigger("CallBack")
                            }
                        })
                        .catch(err => {
                            if (entityName === "cases") {
                                setNaCTrigger("CallBack")
                            }
                            console.error("Error fetching recent mails:", err);
                        });
                }, 2000);
                hideMessage();
                setDisbled(false)
                close()
                setState({
                    size: 'big',
                    tags: [],
                });
                setLinkType("Contacts_Leads,Accounts")
                setSubject("")
                setContent("");
                message.success("Email sent")
                if (entityName !== "cases") {
                    updateStatus(updateId)
                }
                loadingRef.current = false;
                setDoubleClick(false)
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            setDisbled(false)
            message.error(error);
        }
    }
    const ComposeClose = () => {
        toggleSize(entityName === "cases" ? 600 : 1400)
        setPopupMessage(false)
        setDisbled(false)
        close()
        setState({
            size: 'big',
            tags: [],
        });
        setLinkType("Contacts_Leads,Accounts")
        setSubject("")
        setContent("");
    }
    const handleClose = () => {
        setPopupMessage(true)
    }
    const onCancel = () => {
        setPopupMessage(false)
    }
    async function getCompanyEncryption() {
        try {
            const response = await FecthModuleEncryptedToken(profile.companyId, profile.companyId)
            setCompanyToken(response.data)
        } catch (error) {
            message.error(error)
        }
    }
    async function getStripeToken() {
        if (companyDetals.stripeAccountId) {
            try {
                const response = await FecthModuleEncryptedToken(companyDetals.stripeAccountId, profile.companyId)
                setStripeToken(response.data)
            } catch (error) {
                message.error(error)
            }
        }
    }
    async function getAmountEncryption() {
        try {
            const exchangeRate = await getExchangeRate(AllData?.defaultCurrency?.currency, "USD")
            const amount = await ExchangeCurrency(Number(
                AllData?.Calculation?.grandTotal), Number(exchangeRate.data))
            const response = await FecthModuleEncryptedToken(Number(amount), profile.companyId)
            setAmountToken(response.data)
        } catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getCompanyEncryption(),
            getAmountEncryption(),
            getStripeToken(),
        ])
    };
    useEffect(() => {
        if (mailOpen) {
            if (entityName === "cases") {
                setSubject(SubjectData)
                setContent(MailContent)
            }
            if (entityName !== "cases" && MailContent && SubjectData && attachFile) {
                setSubject(SubjectData)
                setContent(MailContent)
                setFiles([attachFile])
            }
            if (entityName === "invoice") {
                fetchAll()
            }
        }
    }, [MailContent, SubjectData, attachFile, mailOpen])
    const edit = true;
    const [participantData, setParticipantData] = useState([])
    const [toSelectedItems, setToSelectedItems] = useState([]);

    // const [openQuery, setOpenQuery] = useState(false);
    const Emailsarray = (emailString) => {
        const newUserList = emailString.map(replayids => {
            let userData = participantData.find(item => item.email === replayids);
            if (!userData) {
                userData = {
                    id: "",
                    name: replayids,
                    type: "Others",
                    email: replayids,
                };
            }
            else {
                userData = {
                    id: userData.id,
                    name: userData.name,
                    type: userData.type,
                    email: userData.email,
                };
            }
            return userData;
        });
        return newUserList;
    };
    async function getPartcipants() {
        try {
            const data = await FetchAllAttendeeList()
            setParticipantData(data)
        }
        catch (error) {
            message.error(error)
        }
    };
    // const handleOpenQureyChange = (newOpen) => {
    //     setOpenQuery(newOpen);
    // };
    // const handleCheckboxChange = (field, isChecked) => {
    //     let updatedFields = linkType.split(',').filter(Boolean);
    //     if (isChecked) {
    //         updatedFields.push(field);
    //     } else {
    //         updatedFields = updatedFields.filter(item => item !== field);
    //     }
    //     setLinkType(updatedFields.join(','));
    // };
    // const Action = (
    //     <div style={{
    //         padding: "0px 20px 0px 20px",
    //         width: "100%",
    //         height: "100%",
    //     }}>
    //         <div>
    //             <Checkbox
    //                 checked
    //                 disabled
    //             >
    //                 Link this email to <b>Contacts/Leads</b> in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //         <div >
    //             <Checkbox
    //                 checked={linkType.includes('Accounts')}
    //                 onChange={(e) => handleCheckboxChange('Accounts', e.target.checked)}
    //             > Link this email to <b>Accounts</b> related to contacts in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //         <div >
    //             <Checkbox
    //                 checked={linkType.includes('Deals')}
    //                 onChange={(e) => handleCheckboxChange('Deals', e.target.checked)}
    //             > Link this email to <b>Deals</b> related to contacts in the &quot;To&quot; field
    //             </Checkbox>
    //         </div>
    //     </div>
    // )
    const downloadAttachment = (attachment) => {
        const blob = new Blob([new Uint8Array(attachment.content.data)], { type: attachment.contentType });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = attachment.filename;
        link.click();
        URL.revokeObjectURL(link.href);
    };
    const removeRow = async (index) => {
        const updatedFormData = [...files];
        updatedFormData.splice(index, 1);
        setFiles(updatedFormData);
    }
    const shortenFilename = (filename, maxLength = 20) => {
        const extension = filename.substring(filename.lastIndexOf('.'));
        const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
        if (nameWithoutExtension.length > maxLength) {
            return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
        }
        return filename;
    };
    useEffect(() => {
        if (mailOpen) {
            if (entityName) {
                getPartcipants()
            }
        }
    }, [entityName, entity, mailOpen])
    useEffect(() => {
        if (mailOpen) {
            if (participantData.length > 0 && toId) {
                const processedUsers = Emailsarray(toId);
                setState({ ...state, tags: processedUsers });
                setToSelectedItems(processedUsers)
            }
        }
    }, [participantData, toId, mailOpen])
    useEffect(() => {
        if (mailOpen) {
            if (templateId.id) {
                getcontent()
            }
        }
    }, [templateId, entityName, mailOpen])
    // cases
    const showConfirm = () => {
        const hasSubject = subject !== undefined && subject !== null && subject !== "";
        const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
        let title;
        let content;
        let okText;
        let cancelText;
        let showCancel;
        let onOkHandler;
        let onCancelHandler;
        if (!hasRecipients) {
            // Case 2: No recipients
            title = (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>No Recipients</span>
                </div>
            );
            content = <p>Please add at least one recipient before sending this message.</p>;
            okText = "OK";
            cancelText = null;
            showCancel = false;
            onOkHandler = (modalInstance) => modalInstance.destroy();
            onCancelHandler = null;
        }
        else if (!hasSubject) {
            // Case 1: Missing subject
            title = (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Missing subject</span>
                </div>
            );
            content = <p>Do you want to send this message without a subject?</p>;
            okText = "Don't send";
            cancelText = "Send";
            showCancel = true;
            onOkHandler = (modalInstance) => modalInstance.destroy();
            onCancelHandler = () => onEmailSend();
        }
        else {
            // Default case (safe fallback)
            return onEmailSend();
        }
        const modalInstance = Modal.confirm({
            title,
            icon: null,
            className: "customice-confirm-modal",
            content,
            centered: true,
            okText,
            cancelText,
            okButtonProps: { className: "gray-buttonModal" },
            cancelButtonProps: { className: "button_colorsModal" },
            okCancel: showCancel,
            onOk: () => onOkHandler(modalInstance),
            onCancel: onCancelHandler,
        });
    };
    const SubjectNameCheck = () => {
        if (subject !== undefined && subject !== null && subject !== "") {
            onEmailSend()
        } else {
            showConfirm()
        }
    }
    const handleAddSignature = () => {
        setContent((prevContent) => {
            const identifier = "signature-block-unique";

            const signatureHtml = `<div id="${identifier}">
      ${profile?.profileSignature || "<div>Add signature</div>"}
    </div>`;
            const spacerDivs = `<div>&nbsp;</div><div>&nbsp;</div>`;
            // Check if signature already exists
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = prevContent;
            const existingSignature = tempDiv.querySelector(`#${identifier}`);

            if (existingSignature) {
                // Replace existing signature
                existingSignature.outerHTML = signatureHtml;
                return tempDiv.innerHTML;
            }
            const replyBlock = tempDiv.querySelector("#ReplyContent");
            if (replyBlock) {
                // Determine target block to insert before
                const targetBlock = replyBlock;

                // Insert signature before the reply/forward section
                const wrapper = document.createElement('div');
                wrapper.innerHTML = `${spacerDivs}${signatureHtml}`;
                targetBlock.parentNode.insertBefore(wrapper, targetBlock);

                return tempDiv.innerHTML;
            }

            const contentToAdd = prevContent.trim() === ""
                ? prevContent.trim() + spacerDivs
                : prevContent.trim();
            // Add new signature
            return `${contentToAdd.trim()}${signatureHtml}`;
        });
    };
    const handleAddInviceLink = () => {
        setContent((prevContent) => {
            const identifier = "payment-link-block";
            const paymentUrl = `${WebUrl}?type=INV&&PA=${amountToken}&&CTID=${companyToken}&&INID=${invoiceToken}&&CUE=${AllData?.data?.billingAddress?.email}&&STID=${stripeToken}`

            // Create the payment link HTML
            const paymentLinkHtml = `<div id="${identifier}" style="margin-top: 10px;">
      <a href="${paymentUrl}" target="_blank" style="color: #1890ff; text-decoration: underline;">
        Click here to pay your invoice
      </a>
    </div>`;

            // Parse the current content
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = prevContent;

            // Check if payment link already exists
            const existingLink = tempDiv.querySelector(`#${identifier}`);

            if (existingLink) {
                // Remove it if it exists
                existingLink.remove();
                setPaymentLinkAdded(false);
                message.success('Payment link removed successfully');
                return tempDiv.innerHTML;
            }

            // ✅ 2. Only check Stripe when INSERTING
            const isStripeReady = companyDetals?.stripeReady;
            if (!isStripeReady) {
                message.warning(
                    "Please set up a payment platform in the Product Integrations page before adding a payment link"
                );
                return prevContent; // important: don't modify content
            }
            // Try to insert after "Total Amount" div
            const invoiceDivs = Array.from(tempDiv.querySelectorAll("div"));
            const totalAmountDiv = invoiceDivs.find(div =>
                div.textContent.includes("Total Amount")
            );

            if (totalAmountDiv) {
                const wrapper = document.createElement("div");
                wrapper.innerHTML = paymentLinkHtml;
                totalAmountDiv.after(wrapper);
            } else {
                // Fallback: append at the end
                tempDiv.appendChild(document.createRange().createContextualFragment(paymentLinkHtml));
            }

            setPaymentLinkAdded(true);
            message.success('Payment link added successfully');
            return tempDiv.innerHTML;
        });
    };
    const OpenTemplates = () => {
        setOpenTemplate(true)
    }
    const SIGNATURE_ID = "signature-block-unique";
    const hasSignature = content?.includes(`id="${SIGNATURE_ID}"`);
    const handleRemoveSignature = () => {
        setContent((prevContent) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = prevContent;

            const signature = tempDiv.querySelector("#signature-block-unique");

            if (signature) {
                signature.remove();
            }

            return tempDiv.innerHTML;
        });
    };
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                width={composeSize}
                open={mailOpen}
                title="Email"
                extra={
                    < Space >
                        <div style={{ display: entityName === "cases" ? "flex" : "none", alignItems: "center", gap: 20 }}>
                            {composeSize === 600 ?
                                <FeatherIcon onClick={() => toggleSize(1200)} icon="maximize-2" size={20} style={{ cursor: "pointer" }} /> :
                                <FeatherIcon onClick={() => toggleSize(600)} icon="minimize-2" size={20} style={{ cursor: "pointer" }} />}
                            {/* <FeatherIcon onClick={() => handleClose()} icon="x" size={20} style={{ cursor: "pointer" }} /> */}
                        </div>
                    </Space >
                }
                footer={[<div className="form_action_button">
                    <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                        <FeatherIcon icon="x" /> Cancel
                    </Button>
                    <Button size="small" onClick={() => SubjectNameCheck()} raised className="button_colors" disabled={state?.tags?.length === 0 || disabled || doubleClick} loading={doubleClick}>
                        {!doubleClick && <FeatherIcon icon="send" />}Send
                    </Button>
                </div>]}
            >
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <div style={{ margin: "20px 40px" }}>
                        <MailBox2>
                            <div className="body email-body" style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ width: entityName === "cases" ? "100%" : "60%" }}>
                                    <div className="body">
                                        <div className="group">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                                                <div className="reply-inner">
                                                    {toSelectedItems.length > 0 && toSelectedItems[0] &&
                                                        <div className='Div_flex'>
                                                            {toSelectedItems?.map((item, index) => (
                                                                <div className='share_image' key={index} title={`${item.name} (${item.type})`} style={{ cursor: "default" }}>
                                                                    <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                                                        : item.type === "User" ? "UserIcon"
                                                                            : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                                                        {item.name?.slice(0, 1).toUpperCase()}
                                                                    </span>
                                                                    <span>{`${item.name.substring(0, 10)}...`}</span>
                                                                    {/* {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => TohandleDeselect(item)} />} */}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    }
                                                    {/* <TopToolBoxClone>
                                              <AutoComplete
                                                style={{ width: "100%", maxWidth: "100%" }}
                                                onSearch={TohandleSearch}
                                                onSelect={TohandleSelect}
                                                options={toOptions}
                                                value={toInputValue}
                                                onChange={setToInputValue}
                                              >
                                                <Input placeholder='To' />
                                              </AutoComplete>
                                            </TopToolBoxClone> */}
                                                </div>
                                            </div>
                                            <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                                        </div>
                                        <div className="group">
                                            <Input placeholder="Subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
                                        </div>
                                        <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }}>
                                            {(entityName === "cases" && toSelectedItems.length === 1) &&
                                                <div className="text_icon" role="button" style={{ cursor: "pointer" }}
                                                    tabIndex={0}
                                                    onClick={OpenTemplates}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            OpenTemplates()
                                                        }
                                                    }}>
                                                    <InsertTempIcon marginRight={5} width={14} height={14} /><span className="text_iconspace">Insert Template</span><DownOutlined style={{ fontSize: '12px' }} />
                                                </div>
                                            }
                                            {!hasSignature ? (
                                                <Buttons
                                                    type="text"
                                                    onClick={handleAddSignature}
                                                    className="signature-Button"
                                                >
                                                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <FeatherIcon icon="plus-circle" className="text_iconspace" size={15} />
                                                        Add Signature
                                                    </span>
                                                </Buttons>
                                            ) : (
                                                <Buttons
                                                    type="text"
                                                    onClick={handleRemoveSignature}
                                                    className="signature-Button"
                                                >
                                                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <FeatherIcon icon="x-circle" className="text_iconspace" size={15} />
                                                        Remove Signature
                                                    </span>
                                                </Buttons>
                                            )}
                                            {entityName === "invoice" ? <Buttons
                                                type="text"
                                                onClick={handleAddInviceLink}
                                                className='signature-Button'
                                            >
                                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <FeatherIcon icon={paymentLinkAdded ? "x-circle" : "plus-circle"} className="text_iconspace" size={15} />
                                                    {paymentLinkAdded ? "Remove payment link" : "Add payment link"}
                                                </span>
                                            </Buttons> : <></>}
                                        </div>
                                        {/*   <div style={{ cursor: "pointer" }}>
                                        <Popover
                                            placement="bottomLeft"
                                            content={Action}
                                            trigger="hover"
                                            open={openQuery}
                                            onOpenChange={handleOpenQureyChange}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <LinkEmailIcon marginRight={5} width={16} height={16} marginBottom={2} /><span className="text_iconspace">Link Email</span><DownOutlined style={{ fontSize: '12px' }} />
                                            </div>
                                        </Popover>
                                    </div>
                                </div> */}
                                        <div className="group">
                                            <TinyMCEEditor placeholder="Compose email..." setContent={setContent} content={content} edit={edit} page="Email" setFiles={setFiles} height={400} selectedEntity="A" />
                                        </div>
                                    </div>
                                </div>
                                {entityName !== "cases" &&
                                    <div style={{ width: "40%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {AllData?.companyData ? (
                                            <PDFViewer width="100%" height="100%">
                                                {entityName === "quotes" &&
                                                    <QuotationPdf data={AllData?.data} profile={profile} theme={AllData?.theme} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.defaultCurrency} Calculation={AllData?.Calculation} />}
                                                {entityName === "salesOrder" &&
                                                    <SalesPdf data={AllData?.data} profile={profile} theme={AllData?.theme} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.defaultCurrency} Calculation={AllData?.Calculation} />}
                                                {entityName === "invoice" &&
                                                    <InvoicePdf data={AllData?.data} profile={profile} theme={AllData?.theme} companyData={AllData?.companyData} tableItem={AllData?.tableItem} tableColum={AllData?.tableColum} currencySettings={AllData?.defaultCurrency} Calculation={AllData?.Calculation} />}
                                            </PDFViewer>
                                        ) : (
                                            <Spin size="small" />
                                        )}
                                    </div>
                                }
                            </div>
                            <div className="group" style={{ marginTop: "20px", display: "flex", gap: 10 }}>
                                {files.map((file, index) => {
                                    const meta = fileTypeMeta(getFileExt(file.filename));
                                    const FileTypeIcon = meta.icon;
                                    return (
                                        <figure
                                            key={index}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 10,
                                                margin: 0,
                                                padding: "5px",
                                                border: "1px solid #e5e7eb",
                                                borderRadius: 10,
                                                background: "#fff",
                                            }}
                                        >
                                            <div
                                                className="attachment-image"
                                                title={meta.label}
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 8,
                                                    background: meta.soft,
                                                    color: meta.color,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <FileTypeIcon size={20} strokeWidth={1.75} />
                                            </div>
                                            <figcaption style={{ flex: 1, marginTop: 0 }}>
                                                <div title={file.filename} style={{
                                                    cursor: "default",
                                                    fontWeight: 700,
                                                    fontSize: 12,
                                                }}>{shortenFilename(file.filename, 20)}</div>
                                                <div style={{
                                                    display: "flex", alignItems: "center", justifyContent: "flex-start",
                                                    gap: '10px',
                                                    marginTop: '5px',
                                                }}>
                                                    <span style={{
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        color: "#4183f1",
                                                        cursor: "pointer",
                                                        flexGrow: 0,
                                                    }} role="button" tabIndex={0}
                                                        onClick={() => downloadAttachment(file)}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                downloadAttachment(file)
                                                            }
                                                        }}> Download
                                                    </span>
                                                    <span style={{
                                                        fontSize: 10,
                                                        fontWeight: 600,
                                                        color: "red",
                                                        cursor: "pointer",
                                                        flexGrow: 0,
                                                    }}>
                                                        <FeatherIcon icon="trash-2" size={10} style={{ marginTop: 2 }} onClick={() => removeRow(index)} />
                                                    </span>
                                                </div>
                                            </figcaption>
                                        </figure>
                                    );
                                })}
                            </div>
                        </MailBox2>
                    </div>
                </Scrollbars>
            </Drawer>
            {openTemplate && <TemplateSelect openTemplate={openTemplate} setOpenTemplate={setOpenTemplate} setTemplateId={setTemplateId} entityName="Cases" />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType="QSI" close={ComposeClose} onclose={onCancel} />}
        </>
    );
}

Compose.propTypes = {
    close: propTypes.func,
    entity: propTypes.string,
    entityName: propTypes.string,
    toId: propTypes.string,
    MailContent: propTypes.string,
    SubjectData: propTypes.string,
    AllData: propTypes.object,
    attachFile: propTypes.object,
    updateStatus: propTypes.func,
    updateId: propTypes.number,
    mailOpen: propTypes.bool,
    entityId: propTypes.number,
    setNaCTrigger: propTypes.func,
    invoiceToken: propTypes.string,
};

Compose.defaultProps = {
    close: () => { },
};

export default Compose;
